import { getDatabase, ref, update } from "firebase/database";
import { getFirebaseApp } from "./firebaseClient";

function gamePath(sessionId) {
  return `/${sessionId}/game`;
}

export async function publishGameEvent(sessionId, eventType, payload = {}) {
  const app = getFirebaseApp();
  if (!app || !sessionId || !process.env.REACT_APP_FIREBASE_DATABASE_URL) return;
  try {
    const db = getDatabase(app);
    await update(ref(db, gamePath(sessionId)), {
      lastEventType: eventType,
      lastEventTs: Date.now(),
      ...payload,
    });
  } catch (e) {
    console.warn("[gameClientRtdb]", e?.message || e);
  }
}
